exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auto-newsletter .mx-datepicker .mx-input-wrapper .mx-input {\n  height: 45px;\n  margin-top: 4px;\n}\n.auto-newsletter .mx-datepicker {\n  width: 100%;\n}\n", ""]);

// exports
